module.exports = __webpack_public_path__ + "img/icon_page4_phone.b76dafe2.png";